import { Helmet } from "react-helmet-async";

const SITE_NAME = "Hitech Transit";
const DEFAULT_TITLE = "Removals Cardiff | Trusted House & Office Movers | Hitech Transit";
const DEFAULT_DESCRIPTION = "Professional removals in Cardiff & South Wales. House moves, office relocations, storage & specialist transport. Fully insured. Free instant quote in 60 seconds.";
const DEFAULT_IMAGE = "https://static.prod-images.emergentagent.com/jobs/80ea756f-7ea3-4803-b754-18b59043e07a/images/d9b70dc68cc964050d6b7582cabdba6cd06668dbb9ef9a403050982926bf0037.png";
const SITE_URL = "https://www.hitechtransit.com";

const SEOHead = ({
  title,
  description,
  canonical,
  ogType = "website",
  ogImage,
  noindex = false,
  jsonLd,
  children,
}) => {
  const pageTitle = title || DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const pageImage = ogImage || DEFAULT_IMAGE;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : undefined;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:site_name" content={SITE_NAME} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />

      {/* Geo */}
      <meta name="geo.region" content="GB-WLS" />
      <meta name="geo.placename" content="Cardiff" />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}

      {children}
    </Helmet>
  );
};

export default SEOHead;
